<div [formGroup]="mainForm">
    <input  formControlName="textDate"   >
</div>

<!-- ng-pattern="/^[0-9]+(\.[0-9]{1,2})?$/"  [textMask]="{mask: datemask}"  -->
<!-- placeHolder="{{placeHolder}}" -->
